// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"511":"0ee26028","549":"ba1c2f00"}[chunkId] + ".chunk.js";
};